
nnip.classes.Quiz = function(questions) {

     "use strict";

    // Variables
    this.questionaire = questions;
    this._disableClass = "disabled";
    this.$quiz = $('#quiz');
    this.$next = $('#nextQuestionButton');
    this.$previous = $('#previousQuestionButton');
    this.$result = $('#result');
    this.$tryAgain = $('#restartQuestionButton');
    this.$endQuiz = $('#exitQuiz');

    this._finishVal = jsLanguageLabel.txtFinish;
    this._nextVal = jsLanguageLabel.txtNext;

    this.$questionArea = $('#questionArea');
    this.$startGame = $('#startDiv');
    this.$startBtn = $("#startBtn");
    this.$questionTpl = $('#questiontmpl');

    this.$quizClass = this;

    this.quiz = {
        questionArray : [],
        userAnswers : [],
        resultsObject : new Object,
        currQuestion : 0,
        questionsNum : 0,
        init : function(ctx){
            var self = this;
            //If data has been load before render only
            if(this.questionArray.length > 0){
                this.render(ctx);
            }
            else{
                this.questionArray = ctx.questionaire.questions;
                this.questionsNum = ctx.questionaire.questions.length;
                
                if (typeof(globalStore.multipleSelectedAccountNumber) !== "undefined" && globalStore.multipleSelectedAccountNumber.length > 1 ){  
                    this.resultsObject['accounts'] = globalStore.multipleSelectedAccountNumber;
                } else {
                    this.resultsObject['accounts'] = [globalStore.selectedAccountNumber];
                }
                
                this.resultsObject['answers'] = [];
                
                //Check that the json is not empty
                if(this.questionsNum === 0) {
                    ctx.$quiz.html('<div class="label-info">sorry there is no questions</div>');
                }else{
                    this.render(ctx);
                    //When only one question
                    if (this.questionsNum === 1) {
                        ctx.$next.text(ctx._finishVal);
                    }
                }
            }
            
            //Previous button selected save user data and render
            //unbind first
            ctx.$previous.unbind();
            ctx.$previous.click(function(event){
                self.saveUserAnswer();
                self.currQuestion--;
                //check if go to the first question
                if(self.currQuestion === 0){
                    ctx.$previous.hide();
                }
                //check if we where at the last question
                if(ctx.$next.text() === ctx._finishVal)
                {
                    ctx.$next.text(ctx._nextVal);
                }
                self.updateProgressBar();
                self.render(ctx);
            });

            //Next button clicked - if last question getResult else get the next question
            //unbind first
            ctx.$next.unbind();
            ctx.$next.click(function(event){
                self.saveUserAnswer();
                
                //Finish - last question
                if(self.currQuestion === (self.questionsNum - 1))
                {
                    self.currQuestion++;
                    self.getResults(ctx);
                }
                //represent the next answer
                else{
                    //Check if curr question was the first show previous button
                    if(self.currQuestion === 0){
                        ctx.$previous.show();
                    }
                    self.currQuestion++;
                    //Promote to the last question
                    if(self.currQuestion === (self.questionsNum - 1)){
                        $(this).text(ctx._finishVal);
                    }
                    self.render(ctx);
                }
                self.updateProgressBar();
            });
            //Try again button clicked reset data
            ctx.$tryAgain.unbind();
            ctx.$tryAgain.click(function(){
                //Init values
                self.userAnswers = [];
                self.currQuestion = 0;
                self.updateProgressBar();
                ctx.$next.text(ctx._nextVal);
                
                ctx.$result.hide();
                ctx.$tryAgain.hide();
                ctx.$endQuiz.hide();
                
                ctx.$next.show();
                ctx.$quiz.show();
                ctx.$previous.show();
                self.render(ctx);
            });  
        },
        question:{
            isSelected : function(){
                return function (val, render) {
                    var rendered = render(val);
                    return (this.id === rendered) ? 'checked' : '';
                };
            }},
        //Build the question view with mustache template and underscore
        render : function (ctx) {
            _.extend(this.question,this.questionArray[this.currQuestion]);
            this.question.num = (this.currQuestion + 1);
            this.question.currentAnswer = this.userAnswers[this.currQuestion];
            wizard.setTemplate(ctx.$quiz, globalStore[docQuestionaireTemplate], this.question);

            //Value was selected enable next and put the value selected
            if(!this.userAnswers[this.currQuestion]){
                ctx.$next.attr("disabled", true).addClass(ctx._disableClass);
            }
            else{
                ctx.$next.attr("disabled", false).removeClass(ctx._disableClass);
            }
            
            if(this.currQuestion === 0){
                ctx.$previous.hide();
            }else {
                ctx.$previous.show();
            }

            //When first radio button selected enable next button
            $('.quizArea label').one('change',function(event){
                ctx.$next.attr("disabled", false).removeClass(ctx._disableClass);
            });
        },
        //Save user selected answer to user answer array
        saveUserAnswer : function(){
            var selected = $('.quizArea input[type=radio]:checked');
            var questionId = $('#question').data('id');
            
            //Add the selected value to the answers array
            this.userAnswers[this.currQuestion] = selected.attr('value');
            
            //Add the answer to the results Object;
            this.resultsObject['answers'][this.currQuestion] = {"questionId":questionId,"questionOptionId": selected.attr('value')};
        },
        updateProgressBar : function() {
          
            var result = parseInt(this.currQuestion) * 100 / parseInt(this.questionsNum);
            if (!isFinite(result)) result = 0;

            var quizModalBar = $('#quizModal').find('.bar');
            quizModalBar.css('width', result+'%');

            var currQuestion = this.currQuestion === this.questionsNum ? this.currQuestion : this.currQuestion+1;
            quizModalBar.text(currQuestion + '/' + this.questionsNum);

        },
        //The result check- go over the question and user results array and check match
        getResults : function(ctx)
        {
            ctx.$result.find('.well').hide();
            ctx.$result.find('.ajaxloader').show();

            docObject.calculateRiskProfile(ctx.$quizClass, this.resultsObject);
            
            ctx.$quiz.hide();
            ctx.$previous.hide();
            ctx.$next.hide();
            ctx.$result.show();
            ctx.$endQuiz.show();
            ctx.$tryAgain.show();
            
        }
    };
    this.quiz.init(this);
    
    this.displayResult = function(data) {
        if(data !== null){
            this.$result.find('.ajaxloader').hide();
            this.$result.find('#'+data.result.toLowerCase()).show();
        }else {
            
        }
    };    
};

